/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */

declare function require(moduleName: string): any; // declare node.js "require" so that we can conditionally import
if (typeof window !== "undefined" && typeof document !== "undefined") { // we're in browser
    // tslint:disable-next-line:no-var-requires
    require("dom4"); // only import actual dom4 if we're in the browser (not server-compatible)
    // we'll still need dom4 types for the TypeScript to compile, these are included in package.json
}

import * as contextMenu from "./context-menu/contextMenu";
export const ContextMenu = contextMenu;

export * from "./alert/alert";
export * from "./breadcrumbs/breadcrumb";
export * from "./button/buttons";
export * from "./collapse/collapse";
export * from "./collapsible-list/collapsibleList";
export * from "./context-menu/contextMenuTarget";
export * from "./dialog/dialog";
export * from "./editable-text/editableText";
export * from "./forms/controls";
export * from "./forms/inputGroup";
export * from "./forms/radioGroup";
export * from "./hotkeys/hotkeys";
export * from "./menu/menu";
export * from "./menu/menuDivider";
export * from "./menu/menuItem";
export * from "./non-ideal-state/nonIdealState";
export * from "./overlay/overlay";
export * from "./popover/popover";
export * from "./popover/svgPopover";
export * from "./portal/portal";
export * from "./progress/progressBar";
export * from "./tooltip/svgTooltip";
export * from "./slider/rangeSlider";
export * from "./slider/slider";
export * from "./spinner/spinner";
export * from "./spinner/svgSpinner";
export * from "./tabs/tab";
export * from "./tabs/tabs";
export * from "./tabs/tabList";
export * from "./tabs/tabPanel";
export * from "./tag/tag";
export * from "./toast/toast";
export * from "./toast/toaster";
export * from "./tooltip/tooltip";
export * from "./tree/tree";
export * from "./tree/treeNode";
